import * as React from "react";
import { SharedDocumentsComponent } from './SharedDocumentsComponent';

export const Indonesia = () => {
    return <SharedDocumentsComponent permissionId="39" path="Indonésia" />
}